import { useEffect } from 'react'
import type { ReactNode } from 'react'
import { useSettingsStore } from '@/state/useSettingsStore'
import { nowInPrague } from '@/lib/clock'

function resolveTheme(setting: 'light' | 'dark' | 'auto'): 'light' | 'dark' {
  if (setting !== 'auto') return setting
  const h = nowInPrague().getHours()
  return h >= 7 && h < 18 ? 'light' : 'dark'
}

export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useSettingsStore((s) => s.theme)

  useEffect(() => {
    const apply = () => {
      const resolved = resolveTheme(theme)
      document.documentElement.setAttribute('data-theme', resolved)
    }
    apply()
    if (theme === 'auto') {
      const id = window.setInterval(apply, 5 * 60 * 1000)
      return () => window.clearInterval(id)
    }
    return undefined
  }, [theme])

  return <>{children}</>
}
